/* Quicktrolly postcode logic – phase 2 (18 Oct 2026). Germany market only.
   Own-delivery postcodes = Munich city + surrounding + Group A + outer area (Group B) + QT towns + Moosburg (138)
   (same list as the Parcelify own-delivery zones, 15-16 Oct 2026).
   Products tagged ships-munich (read from /collections/ships-munich/products.json) are delivered
   only to these postcodes. Nothing is hidden until a postcode is known. Logged-in customers with a
   saved German address are never asked. No pop-ups: the panel is inline on fresh/frozen/dairy collections. */
(function () {
  var FLEET = new Set("80331 80333 80335 80336 80337 80339 80469 80538 80539 80634 80636 80637 80638 80639 80686 80687 80689 80796 80797 80798 80799 80801 80802 80803 80804 80805 80807 80809 80933 80935 80937 80939 80992 80993 80995 80997 80999 81241 81243 81245 81247 81249 81369 81371 81373 81375 81377 81379 81475 81476 81477 81479 81539 81541 81543 81545 81547 81549 81667 81669 81671 81673 81675 81677 81679 81735 81737 81739 81825 81827 81829 81925 81927 81929 82008 82024 82041 82049 82054 82061 82064 82065 82110 82131 82140 82152 82166 82178 82194 82205 82216 82256 82319 82515 82538 83607 83624 83629 84079 85221 85354 85356 85368 85375 85386 85399 85408 85410 85416 85419 85435 85521 85540 85551 85560 85567 85570 85579 85586 85591 85598 85599 85604 85609 85614 85622 85630 85635 85640 85649 85653 85662 85716 85737 85748 85757 85764 85774".split(' '));
  var PANEL_COLLECTIONS = 'fresh-produce-1,fruits,vegetables,herbs,frozen-convenience,frozen-indian-breads-snacks,frozen-icecream,dairy,milk,cheese,eggs,yogurt,butter-milk,ghee-butter,butter-cheese-spreads,discount-fresh-produce,bread-buns-rolls'.split(',');
  var KEY = 'qt_plz';
  var cfg = window.QT_PLZ || {};
  if (cfg.country !== 'DE') return;
  var de = cfg.locale === 'de';
  function t(en, d) { return de ? d : en; }
  var BOX = 'margin:0 0 16px;padding:12px 16px;background:#f2f1ec;border:1px solid #e4e2da;color:#031a2f;font-size:14px;line-height:1.5;border-radius:8px;';

  function valid(p) { return /^\d{5}$/.test(p || ''); }
  /* Postcode source: entered postcode (localStorage) > saved address of a logged-in customer.
     After "Change postcode" the saved address is ignored (flag qt_plz_manual) until a new postcode is entered. */
  function get() {
    try {
      var v = localStorage.getItem(KEY); if (valid(v)) return v;
      if (localStorage.getItem(KEY + '_manual')) return null;
    } catch (e) {}
    return valid(cfg.customerZip) ? cfg.customerZip : null;
  }
  function set(p) { try { localStorage.setItem(KEY, p); localStorage.removeItem(KEY + '_manual'); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); if (valid(cfg.customerZip)) localStorage.setItem(KEY + '_manual', '1'); } catch (e) {} }
  function inFleet(p) { return FLEET.has(p); }
  /* ---- delivery zones (Parcelify Germany rates, 8-16 Oct 2026) ---- */
  var Z_B = new Set('85653 85591 85598 85599 85622 82131 85609 85551 85737 82178 82194 85764 85757'.split(' '));
  var Z_QT = new Set('85354 85356 85386 85375 85399 85221 82216 82205 85570 85586 85604 85614 85567 85560 85435 82319 83607 83624 83629 82515 82538'.split(' '));
  var Z_MOOS = new Set('85368 85419 84079 85416 85410 85408'.split(' '));
  var Z_NOEVE = new Set('82256 82140 85716 85748'.split(' '));
  function zone(p) {
    if (!p) return null;
    if (!inFleet(p)) return 'de_rest';
    if (Z_MOOS.has(p)) return 'moosburg';
    if (Z_QT.has(p)) return 'qt_towns';
    if (Z_B.has(p)) return 'munich_b';
    if (Z_NOEVE.has(p)) return 'munich_day';
    return 'munich';
  }
  var ZONE_LINES = {
    munich:     [['Same-day delivery to your door – order by 8 PM. Free from €15.', 'Lieferung noch heute bis an die Tür – bis 20 Uhr bestellen. Gratis ab 15 €.'],
                 ['Choose your slot at checkout: today 2–8 PM, this evening 7–10 PM or tomorrow 2–8 PM.', 'Zeitfenster im Checkout wählen: heute 14–20 Uhr, heute Abend 19–22 Uhr oder morgen 14–20 Uhr.']],
    munich_day: [['Same-day delivery to your door – order by 1 PM. Free from €15.', 'Lieferung noch heute bis an die Tür – bis 13 Uhr bestellen. Gratis ab 15 €.'],
                 ['Choose your slot at checkout: today 2–8 PM or tomorrow 2–8 PM.', 'Zeitfenster im Checkout wählen: heute 14–20 Uhr oder morgen 14–20 Uhr.']],
    munich_b:   [['Delivered to your door by the Quicktrolly team – free from €35.', 'Lieferung bis an die Tür durch das Quicktrolly-Team – gratis ab 35 €.'],
                 ['Choose your slot at checkout: today 2–8 PM (order by 1 PM) or tomorrow 2–8 PM.', 'Zeitfenster im Checkout wählen: heute 14–20 Uhr (bis 13 Uhr bestellen) oder morgen 14–20 Uhr.']],
    qt_towns:   [['Delivered to your door by the Quicktrolly team in 1–3 working days – free from €35.', 'Lieferung bis an die Tür durch das Quicktrolly-Team in 1–3 Werktagen – gratis ab 35 €.'],
                 ['Fresh, chilled and frozen items included – we’ll confirm your delivery day.', 'Frische, gekühlte und tiefgekühlte Artikel inklusive – wir bestätigen Ihren Liefertag.']],
    moosburg:   [['Weekly delivery to your door by the Quicktrolly team – free from €15.', 'Wöchentliche Lieferung bis an die Tür durch das Quicktrolly-Team – gratis ab 15 €.'],
                 ['Your delivery day is announced in our WhatsApp group.', 'Den Liefertag geben wir in unserer WhatsApp-Gruppe bekannt.']],
    de_rest:    [['Delivered to your door anywhere in Germany in 1–3 working days – free from €34.99.', 'Lieferung bis an die Tür in ganz Deutschland in 1–3 Werktagen – gratis ab 34,99 €.'],
                 ['Great brands, fair prices – your online grocery store in Germany.', 'Starke Marken, faire Preise – Ihr Online-Supermarkt in Deutschland.']]
  };
  /* Announcement bar: the two Germany-only postcode slides get zone-specific text once a postcode is known
     (the bar is an Alpine slideshow, so slides are never added or removed, only their text changes). */
  function applyBanner(plz) {
    var z = zone(plz), lines = z && ZONE_LINES[z];
    document.querySelectorAll('.section-announcement [class*="carousel-style-"]').forEach(function (wrap) {
      var i = 0;
      wrap.querySelectorAll('.slide-item a').forEach(function (a) {
        if (!a.hasAttribute('data-qt-orig')) {
          var orig = a.textContent.trim();
          if (!/your postcode|ihre plz|munich|münchen/i.test(orig)) return;
          a.setAttribute('data-qt-orig', orig);
        }
        var txt = lines && lines[i] ? t(lines[i][0], lines[i][1]) : a.getAttribute('data-qt-orig');
        i++;
        if (a.textContent.trim() !== txt) a.textContent = txt;
      });
    });
  }
  /* Top bar: show the postcode next to the country ("Germany · English · 80331") and offer a
     postcode field inside the country/language panel, so it can be seen and changed from any page. */
  function applyTopBar(plz) {
    document.querySelectorAll('.localization-form').forEach(function (form) {
      var label = form.querySelector('.select-toggle .select-text');
      if (label) {
        if (!label.hasAttribute('data-qt-orig')) label.setAttribute('data-qt-orig', label.textContent.trim());
        var want = label.getAttribute('data-qt-orig') + (plz ? ' · ' + plz : '');
        if (label.textContent.trim() !== want) label.textContent = want;
      }
      var panel = form.querySelector('.select-listbox');
      if (!panel) return;
      var box = panel.querySelector('.qt-plz-topbar');
      if (!box) {
        box = document.createElement('div'); box.className = 'qt-plz-topbar';
        box.innerHTML = '<span class="inline-block mb-1.5 font-semibold">' + t('Postcode', 'PLZ') + '</span>' +
          '<div class="qt-plz-topbar-form" style="display:flex;gap:6px;align-items:center;">' +
            '<input type="text" inputmode="numeric" maxlength="5" placeholder="' + t('Postcode', 'PLZ') + '" aria-label="' + t('Postcode', 'Postleitzahl') + '" style="flex:1;min-width:0;padding:8px 10px;border:1px solid rgba(var(--color-text),0.25);border-radius:6px;font-size:14px;background:transparent;color:inherit;" onclick="event.stopPropagation()" onkeydown="event.stopPropagation()" onkeyup="event.stopPropagation()">' +
            '<button type="button" class="button button-secondary" style="padding:6px 12px;font-size:13px;">' + t('Check', 'Prüfen') + '</button>' +
          '</div>' +
          '<div class="qt-plz-topbar-known" style="display:none;align-items:center;gap:8px;font-size:14px;"><span></span><a href="#" style="text-decoration:underline;">' + t('Change', 'Ändern') + '</a></div>';
        var save = panel.querySelector('custom-button');
        if (save) panel.insertBefore(box, save); else panel.appendChild(box);
        var inp = box.querySelector('input');
        box.querySelector('button').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); api.submit(inp); });
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); api.submit(inp); } });
        box.querySelector('.qt-plz-topbar-known a').addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); api.change(); inp.focus(); });
      }
      var f = box.querySelector('.qt-plz-topbar-form'), k = box.querySelector('.qt-plz-topbar-known');
      if (plz) { f.style.display = 'none'; k.style.display = 'flex'; k.querySelector('span').textContent = t('Delivering to ', 'Lieferung nach ') + plz; }
      else { f.style.display = 'flex'; k.style.display = 'none'; }
    });
  }
  function restricted() { var p = get(); return !!p && !inFleet(p); }

  /* ---- own-delivery-only product handles (cached per session) ---- */
  var munich = null, loading = null;
  function loadMunich() {
    if (munich) return Promise.resolve(munich);
    if (loading) return loading;
    try { var c = sessionStorage.getItem('qt_munich_handles'); if (c) { munich = new Set(JSON.parse(c)); return Promise.resolve(munich); } } catch (e) {}
    loading = fetch('/collections/ships-munich/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        munich = new Set((j.products || []).map(function (p) { return p.handle; }));
        try { sessionStorage.setItem('qt_munich_handles', JSON.stringify(Array.from(munich))); } catch (e) {}
        return munich;
      }).catch(function () { munich = new Set(); return munich; });
    return loading;
  }
  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : null;
  }

  /* ---- product cards (collections, carousels, search) ---- */
  function hideCards() {
    document.querySelectorAll('.product-card__wrapper').forEach(function (c) {
      if (c.getAttribute('data-qt-checked')) return;
      var a = c.querySelector('a[href*="/products/"]'); var h = handleFromHref(a && a.getAttribute('href'));
      if (!h || !munich.has(h)) return;
      c.setAttribute('data-qt-checked', '1');
      var box = c.closest('.grid-item') || c.closest('.slide-item') || c;
      box.setAttribute('data-qt-hidden', '1'); box.style.display = 'none';
    });
  }
  function showCards() {
    document.querySelectorAll('[data-qt-hidden]').forEach(function (b) { b.style.display = ''; b.removeAttribute('data-qt-hidden'); });
    document.querySelectorAll('[data-qt-checked]').forEach(function (b) { b.removeAttribute('data-qt-checked'); });
  }

  /* ---- inline panel on fresh/frozen/dairy collections ---- */
  function ensurePanel() {
    if (cfg.template !== 'collection' || PANEL_COLLECTIONS.indexOf(cfg.collection) < 0) return null;
    var panel = document.getElementById('qt-plz-panel');
    if (panel) return panel;
    var anchor = document.querySelector('.region-availability-note') || document.getElementById('ItemsGrid') || document.getElementById('product-grid');
    if (!anchor) return null;
    panel = document.createElement('div'); panel.id = 'qt-plz-panel'; panel.setAttribute('style', BOX);
    panel.innerHTML =
      '<form class="qt-plz-form" novalidate style="display:flex;flex-wrap:wrap;align-items:center;gap:10px;">' +
        '<span style="flex:1 1 220px;">' + t('Enter your postcode to see what we deliver to you.', 'Geben Sie Ihre PLZ ein, um zu sehen, was wir zu Ihnen liefern.') + '</span>' +
        '<input name="plz" type="text" inputmode="numeric" maxlength="5" placeholder="' + t('Postcode', 'PLZ') + '" aria-label="' + t('Postcode', 'Postleitzahl') + '" style="width:110px;padding:8px 10px;border:1px solid #c9c6bc;border-radius:6px;font-size:14px;">' +
        '<button type="submit" style="padding:8px 16px;border-radius:6px;background:#1C3C21;color:#fff;border:0;font-size:14px;cursor:pointer;">' + t('Check', 'Prüfen') + '</button>' +
      '</form>' +
      '<div class="qt-plz-known" hidden style="display:flex;flex-wrap:wrap;align-items:center;gap:10px;">' +
        '<span>' + t('Delivering to', 'Lieferung nach') + ' <strong class="qt-plz-value"></strong></span>' +
        '<a href="#" class="qt-plz-change" style="text-decoration:underline;">' + t('Change postcode', 'PLZ ändern') + '</a>' +
      '</div>';
    var note = document.createElement('div'); note.id = 'qt-plz-note'; note.hidden = true; note.setAttribute('style', BOX + 'text-align:center;');
    anchor.parentNode.insertBefore(panel, anchor);
    anchor.parentNode.insertBefore(note, anchor);
    panel.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); api.submit(this.plz); });
    panel.querySelector('.qt-plz-change').addEventListener('click', function (e) { e.preventDefault(); api.change(); });
    return panel;
  }
  function renderPanel(plz) {
    var panel = ensurePanel(); if (!panel) return;
    var form = panel.querySelector('.qt-plz-form'), known = panel.querySelector('.qt-plz-known'), note = document.getElementById('qt-plz-note');
    if (!plz) { form.hidden = false; known.hidden = true; known.style.display = 'none'; form.style.display = 'flex'; note.hidden = true; return; }
    form.hidden = true; form.style.display = 'none'; known.hidden = false; known.style.display = 'flex';
    known.querySelector('.qt-plz-value').textContent = plz;
    if (inFleet(plz)) { note.hidden = true; return; }
    var grid = document.getElementById('ItemsGrid');
    var left = grid ? Array.prototype.filter.call(grid.querySelectorAll('.product-card__wrapper'), function (c) { return !c.closest('[data-qt-hidden]'); }).length : 1;
    note.textContent = left === 0
      ? t('Products in this category are coming soon to ' + plz + '.', 'Die Produkte dieser Kategorie sind bald auch für ' + plz + ' erhältlich.')
      : t('At the moment, the products below are available for delivery to ' + plz + '. More are coming soon.',
          'Derzeit sind die unten stehenden Produkte für die Lieferung nach ' + plz + ' verfügbar. Weitere folgen in Kürze.');
    note.hidden = false;
  }

  /* ---- product page ---- */
  function applyProduct(plz) {
    if (cfg.template !== 'product' || !cfg.product || !munich.has(cfg.product)) return;
    var isR = !!plz && !inFleet(plz);
    var pn = document.getElementById('qt-plz-product-note');
    if (!pn) {
      var host = document.querySelector('main-product'); if (!host) return;
      pn = document.createElement('div'); pn.id = 'qt-plz-product-note'; pn.setAttribute('style', BOX);
      pn.innerHTML = t('This product will be available for delivery to your region soon – please check back. ',
                       'Dieses Produkt ist bald auch für Ihre Region lieferbar – schauen Sie gern wieder vorbei. ') +
        '<a href="#" class="qt-plz-change" style="text-decoration:underline;">' + t('Change postcode', 'PLZ ändern') + '</a>';
      host.parentNode.insertBefore(pn, host);
      pn.querySelector('.qt-plz-change').addEventListener('click', function (e) { e.preventDefault(); api.change(); });
    }
    pn.hidden = !isR;
    document.querySelectorAll('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]').forEach(function (b) {
      if (isR) { b.disabled = true; b.setAttribute('data-qt-disabled', '1'); }
      else if (b.getAttribute('data-qt-disabled')) { b.disabled = false; b.removeAttribute('data-qt-disabled'); }
    });
  }

  /* ---- cart drawer / cart page ---- */
  function gateCheckout(block) {
    document.querySelectorAll('button[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]').forEach(function (b) {
      if (block) { b.disabled = true; b.setAttribute('data-qt-disabled', '1'); b.style.opacity = '.5'; b.style.pointerEvents = 'none'; }
      else if (b.getAttribute('data-qt-disabled')) { b.disabled = false; b.removeAttribute('data-qt-disabled'); b.style.opacity = ''; b.style.pointerEvents = ''; }
    });
    document.querySelectorAll('[data-shopify="dynamic-checkout-cart"], .additional-checkout-buttons').forEach(function (d) {
      if (block) { d.setAttribute('data-qt-hidden-dc', '1'); d.style.display = 'none'; }
      else if (d.getAttribute('data-qt-hidden-dc')) { d.style.display = ''; d.removeAttribute('data-qt-hidden-dc'); }
    });
  }
  var cartTimer;
  function applyCart(plz) {
    var host = document.querySelector('.cart-items__container, .cart-items__body'); if (!host) return;
    var box = document.getElementById('qt-plz-cart-note');
    if (!box) {
      box = document.createElement('div'); box.id = 'qt-plz-cart-note'; box.hidden = true;
      box.setAttribute('style', 'margin:8px 0 12px;padding:10px 12px;border-radius:8px;background:#fff4e5;border:1px solid #ffe0b2;color:#7a4b00;font-size:13px;line-height:1.5;');
      var anchorEl = host.closest('form') || host;  /* never inside the cart <form>: a nested form is dropped by the browser */
      anchorEl.parentNode.insertBefore(box, anchorEl);
    }
    if (plz && inFleet(plz)) { box.hidden = true; gateCheckout(false); return; }
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var names = (cart.items || []).filter(function (i) { return munich.has(i.handle); }).map(function (i) { return i.product_title; });
        gateCheckout(names.length > 0);
        if (!names.length) { box.hidden = true; return; }
        if (!plz) {
          /* own-delivery-only item in the basket but no postcode yet: ask inline before checkout. */
          if (!box.querySelector('.qt-plz-cart-input')) {
            box.innerHTML = '<div style="margin-bottom:8px;">' + t('Please enter your postcode to confirm delivery to your address.', 'Bitte geben Sie Ihre PLZ ein, um die Lieferung an Ihre Adresse zu bestätigen.') + '</div>' +
              '<div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px;">' +
              '<input class="qt-plz-cart-input" type="text" inputmode="numeric" maxlength="5" placeholder="' + t('Postcode', 'PLZ') + '" aria-label="' + t('Postcode', 'Postleitzahl') + '" style="width:110px;padding:7px 10px;border:1px solid #e0c48a;border-radius:6px;font-size:13px;">' +
              '<button type="button" class="qt-plz-cart-btn" style="padding:7px 14px;border-radius:6px;background:#1C3C21;color:#fff;border:0;font-size:13px;cursor:pointer;">' + t('Check', 'Prüfen') + '</button></div>';
            var inp = box.querySelector('.qt-plz-cart-input');
            box.querySelector('.qt-plz-cart-btn').addEventListener('click', function () { api.submit(inp); });
            inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); api.submit(inp); } });
          }
          box.hidden = false;
          return;
        }
        box.innerHTML = t('⚠️ These items aren’t available for ' + plz + ' – coming soon: ' + names.join(', ') + '. Please remove them to continue.',
                          '⚠️ Diese Artikel sind für ' + plz + ' noch nicht verfügbar – bald lieferbar: ' + names.join(', ') + '. Bitte entfernen Sie sie, um fortzufahren.');
        box.hidden = false;
      }).catch(function () {});
    }, 200);
  }

  var applying = false;
  function apply() {
    if (applying) return; applying = true;
    loadMunich().then(function () {
      var plz = get();
      if (plz && !inFleet(plz)) hideCards(); else showCards();
      renderPanel(plz); applyProduct(plz); applyCart(plz); applyBanner(plz); applyTopBar(plz);
    }).finally(function () { applying = false; });
  }

  var api = window.qtPostcode = {
    get: get,
    isFleet: function () { var p = get(); return !!p && inFleet(p); },
    zone: function () { return zone(get()); },
    submit: function (input) {
      var p = (input.value || '').trim();
      if (!valid(p)) { input.setCustomValidity(t('Please enter a 5-digit postcode', 'Bitte eine 5-stellige PLZ eingeben')); input.reportValidity(); return false; }
      input.setCustomValidity(''); set(p); apply(); return false;
    },
    change: function () { clear(); apply(); var i = document.querySelector('#qt-plz-panel input'); if (i) { i.value = ''; i.focus(); } }
  };

  function start() {
    apply();
    var timer;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { clearTimeout(timer); timer = setTimeout(apply, 200); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
